export const UPLOAD_IMAGES_IMPORT_WIZARD = 'UPLOAD_IMAGES_IMPORT_WIZARD';
export type UPLOAD_IMAGES_IMPORT_WIZARD = typeof UPLOAD_IMAGES_IMPORT_WIZARD;

export interface UploadImagesImportWizard {
    type: UPLOAD_IMAGES_IMPORT_WIZARD;
}

export function uploadImagesImportWizardAction(): UploadImagesImportWizard {
    return {
        type: UPLOAD_IMAGES_IMPORT_WIZARD
    };
}
